// Cliente del Calendario Familiar (endpoints /cal/* del Cloudflare Worker).
const CAL_BASE = (
  process.env.REACT_APP_CAL_WORKER_URL
  || "https://preguntale-a-papi.guendelman.workers.dev"
).replace(/\/+$/, "");

const TOKEN_KEY = "cal_token";
const PERSON_KEY = "cal_person";

export const ERRORS = {
  persona_no_existe: "No encontramos a esa persona en la lista",
  ya_registrado: "Esa persona ya creó su clave. Usa \"Ya tengo clave\"",
  no_registrado: "Todavía no creas tu clave. Usa \"Primera vez\"",
  clave_muy_corta: "La clave tiene que tener al menos 4 caracteres",
  clave_incorrecta: "Clave incorrecta",
  bloqueado: "Muchos intentos fallidos. Espera 15 minutos y prueba de nuevo",
  no_autenticado: "Tu sesión expiró, entra de nuevo",
  fecha_invalida: "Esa fecha no es válida",
  fecha_hebrea_invalida: "Esa fecha hebrea no existe",
  sin_cambios: "No hay nada que enviar",
  saludo_invalido: "Escribe un saludo primero",
  unauthorized: "Clave de administrador incorrecta",
};

export const getCalToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const getCalPerson = () => {
  try { return JSON.parse(localStorage.getItem(PERSON_KEY) || "null"); } catch { return null; }
};
export function saveCalSession(token, person) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(PERSON_KEY, JSON.stringify(person));
}
export function clearCalSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(PERSON_KEY);
}

export async function calFetch(path, { method = "GET", body, admin } = {}) {
  const headers = { "Content-Type": "application/json" };
  const token = getCalToken();
  if (token) headers.Authorization = `Bearer ${token}`;
  if (admin) headers["x-admin-password"] = admin;
  const res = await fetch(`${CAL_BASE}${path}`, { method, headers, body: body ? JSON.stringify(body) : undefined });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.error) {
    const code = String(json.error || "error").replace(/_(hdate|gdate|death_hdate|death_gdate)$/, "");
    const err = new Error(ERRORS[code] || json.detail || json.error || "Algo falló, prueba de nuevo");
    err.code = json.error;
    err.status = res.status;
    throw err;
  }
  return json;
}

export const localYmd = (d = new Date()) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const HEBREW_MONTHS = [
  ["Tishrei", "Tishrei"], ["Cheshvan", "Jeshván"], ["Kislev", "Kislev"], ["Tevet", "Tevet"],
  ["Shvat", "Shvat"], ["Adar", "Adar"], ["Adar I", "Adar I"], ["Adar II", "Adar II"],
  ["Nisan", "Nisán"], ["Iyyar", "Iyar"], ["Sivan", "Siván"], ["Tamuz", "Tamuz"], ["Av", "Av"], ["Elul", "Elul"],
];
export const hebMonthEs = (m) => (HEBREW_MONTHS.find(([k]) => k === m) || [m, m])[1];
export const fmtHebrew = (h) => (h && h.day ? `${h.day} de ${hebMonthEs(h.month)} ${h.year}` : "—");
export const fmtGreg = (s) => {
  if (!s) return "—";
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("es-CL", { day: "numeric", month: "long", year: "numeric" });
};
export const CELEBRATE_OPTIONS = [
  ["both", "En ambos calendarios", "Te saludamos en tu cumple gregoriano y también en el hebreo"],
  ["gregorian", "Solo el gregoriano", "El de siempre, el del carnet"],
  ["hebrew", "Solo el hebreo", "Según el calendario judío; cambia de fecha cada año"],
];
